import { server } from './config'
import client from './client'

export default {
  getCheckin(language) {
    const url = sessionStorage.getItem('url'),
      propertyId = sessionStorage.getItem('propertyId'),
      bookingId = sessionStorage.getItem('bookingId')

    return client.get(
      `${url}/checkin/api/booking?propertyId=${propertyId}&bookingId=${bookingId}&language=${language}`
    )
  },

  saveCheckin(data) {
    const baseUrl = sessionStorage.getItem('url'),
      locale = sessionStorage.getItem('locale'),
      property = sessionStorage.getItem('propertyId'),
      booking = sessionStorage.getItem('bookingId')

    const url = `${baseUrl}/checkin/api/save?language=${locale}&propertyId=${property}&bookingId=${booking}`

    return client.post(url, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  findReservation({ reservationId }) {
    return client.get(`${server}/checkin/api/findReservation?reservation=${reservationId}`)
  }
}
